import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import AppSimple from "./AppSimple";

Sentry.init({
  dsn: "https://a75c5f407c58001234d432b97c7f2e6c@o4510948339613696.ingest.us.sentry.io/4511350526705664",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

const Component = window.location.pathname === "/teste-seu-ingles" ? AppSimple : App;

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary fallback={<p>Algo deu errado. Tente recarregar a página.</p>}>
    <React.StrictMode>
      <Component />
    </React.StrictMode>
  </Sentry.ErrorBoundary>
);
